@if (commentsAndRepliesExist) {
  <svg-icon
    class="comment-bubble-icon w-full h-full absolute top-0 left-0 text-blue-90"
    [ngClass]="{ 'group-hover:text-blue-70': !disabled }"
    [src]="'commenting/comment-bubble'">
  </svg-icon>

  <span class="text-white z-0">{{ commentsAndRepliesCount }}</span>
} @else {
  <svg-icon
    class="add-comment-icon w-full h-full invisible"
    [ngClass]="{ 'group-hover:visible': !disabled }"
    [src]="'commenting/add-comment'">
  </svg-icon>

  <svg-icon
    class="no-comment-icon w-full h-full visible absolute top-0 left-0 text-navy-70"
    [ngClass]="{ 'group-hover:invisible': !disabled }"
    [src]="'commenting/no-comment'">
  </svg-icon>
}
